import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27c059f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "get-team" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Paste a Figma team link"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Go to "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://figma.com/",
      target: "_blank"
    }, "figma.com"),
    /*#__PURE__*/_createTextVNode(" and copy the link from your team, "),
    /*#__PURE__*/_createElementVNode("a", { href: "#" }, "see how")
  ])
], -1))
const _hoisted_3 = { class: "input-wrapper" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "spinner light"
}
const _hoisted_6 = { key: 1 }

import { ref } from "vue"
import { postData } from "@/api"
import { useUserStore } from "@/store"
import { notify } from "@/globals/notification"
import WebhookModal from "@/components/modals/WebhookModal.vue"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useUserStore()

const data = ref({
  team_url: ""
})

const show = ref(false)
const loading = ref(false)

const modal_webhook = ref([])
const webhook_index = ref(null)

const closeModal = () => {
  show.value = false
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const openWebhookSettings = (data: any) => {
  show.value = true
  store.webhooks.push(data)
  const _index = store.webhooks.indexOf(data)
  modal_webhook.value = data
  webhook_index.value = _index
}

const get_team_id = async () => {
  loading.value = true
  const get_team_id = await postData(
    `${process.env.VUE_APP_API_URL}/figma/get-team-id`,
    data.value
  )

  if ("error" in get_team_id) {
    loading.value = false
    notify(get_team_id.error, true)
    return
  }

  notify(`${get_team_id.team.team_name} added!`, false)
  loading.value = false
  data.value.team_url = ""
  openWebhookSettings(get_team_id)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (show.value)
      ? (_openBlock(), _createBlock(WebhookModal, {
          key: 0,
          webhook: modal_webhook.value,
          webhook_index: webhook_index.value,
          onCloseModal: closeModal
        }, null, 8, ["webhook", "webhook_index"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.value.team_url) = $event)),
          placeholder: "Paste Figma team link"
        }, null, 512), [
          [_vModelText, data.value.team_url]
        ]),
        _createElementVNode("button", {
          onClick: _withModifiers(get_team_id, ["prevent"])
        }, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
            : _createCommentVNode("", true),
          (!loading.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Add"))
            : _createCommentVNode("", true)
        ], 8, _hoisted_4)
      ])
    ])
  ], 64))
}
}

})